import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const CHATS_PER_PAGE = 100;

export const useGetChatsList = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
    chatService: true,
  });

  const getChatsList = (page: number = 1, limit: number = CHATS_PER_PAGE) => {
    send({}, `/api/v1/conversation?limit=${limit}&page=${page}`).then();
  };

  return {
    getChatsList,
    data,
    isLoading,
    error,
  };
};
